/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

export const APP_STATE = "ERPSALEMAN";
export const API = "/api";
export const DEBUG = false;
export const DEBUG_ID = "U5d3b1a1aec610bf29f449fe1cc1898xx4";
export const DEBUG_TOKEN = "eyJraWQiOiIwZjdhYzBmOGEyMmUxMzFiNWZlNz";
export const DEBUG_NAME = "Tester";
export const DEBUG_PIC = "https://picsum.photos/id/1/300/300";
export const DEBUG_STATUS = "Dev Test";
export const DEBUG_EMAIL = "rahuserpent19@gmail.com";

export const APP_NAME = "";
export const API_URL = "";

/* LINE LIFF */
export const LIFF_ID = "2004599496-AVB8O64D";
